module.exports = __webpack_public_path__ + "static/img/anxunu02.baac2b08.svg";